import {
  Button,
  COLORS,
  GenericIconName,
  Icon,
  Text,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

interface CoinsGenericSectionProps {
  ['data-testid']?: string;
  className?: string;
  title: string;
  description?: string;
  href?: string;
  onClick?: VoidFunction;
}

export const CoinsLinkSection: React.FC<
  React.PropsWithChildren<CoinsGenericSectionProps>
> = ({
  'data-testid': dataTestId,
  className,
  title,
  description,
  href,
  onClick,
  children,
}) => {
  return (
    <Wrapper className={className} data-testid={dataTestId}>
      <LinkButton
        href={href}
        onClick={onClick}
        variant="secondary"
        aria-label={undefined}
      >
        <TextWrapper>
          <Text size="px16" weight="mediumHeavy">
            {title}
          </Text>
          {description && (
            <Text color="Grey0" size="px12" weight="mediumBold">
              {description}
            </Text>
          )}
        </TextWrapper>
        <Icon asset={GenericIconName.ArrowRight} size="SS" />
      </LinkButton>

      {children && <ChildrenContent>{children}</ChildrenContent>}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid ${COLORS.Grey3};
  border-radius: 8px;
`;

const LinkButton = styled(Button)`
  &&& {
    gap: 4px;
    padding: 16px;
    background: transparent;
    height: auto;
    box-shadow: none;

    > span {
      display: flex;
      align-items: center;
      flex: 1;
      padding: 0;
    }
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 4px;
  text-align: left;
`;

const ChildrenContent = styled.div`
  width: 100%;
  border-top: 1px solid ${COLORS['Outline.Grey']};
  padding: 16px;
`;
